import { fsc, enableFSC } from 'config';

const { featureName: galleryFeatureName } = fsc;

export class FSCEvent {
  constructor(feature, view) {
    this.event = {
      feature,
      view
    };
  }

  // Used for setting up actions (including custom, non-supported actions)
  action(actionName, elementName) {
    this.event.action = actionName;
    this.event.element = elementName;
    return this;
  }

  // Wraps sending the FSC event
  send(options) {
    if (enableFSC) {
      window.FSC.send(
        this.event,
        {
          payload: this.payload
        },
        options
      );
    }
  }

  // Merges payload objects
  withPayload(payloadObj) {
    this.payload = {
      ...this.payload,
      ...payloadObj
    };
    return this;
  }

  Selected(elementName) {
    return this.action('Selected', elementName);
  }

  Shown(elementName) {
    return this.action('Shown', elementName);
  }

  Tapped(elementName) {
    return this.action('Tapped', elementName);
  }

  Viewed(elementName) {
    return this.action('Viewed', elementName);
  }
}

export class FSCFeature {
  constructor(featureName) {
    this.name = featureName;
  }

  view(viewName) {
    return new FSCEvent(this.name, viewName);
  }
}

export const feature = (featureName) => new FSCFeature(featureName);

// Create the default App Gallery feature for use in other components
export default feature(galleryFeatureName);
